import React from 'react';
import Icon from '../../components/AppIcon';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  disabled = false,
  loading = false,
  fullWidth = false,
  type = 'button',
  onClick,
  className = '',
  ...props
}) => {
  // Base classes
  const baseClasses = 'btn inline-flex items-center justify-center font-medium transition-all rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2';
  
  // Size classes
  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
  };
  
  // Variant classes
  const variantClasses = {
    primary: 'bg-primary text-white hover:bg-primary-dark focus:ring-primary',
    secondary: 'bg-white text-primary border border-primary hover:bg-surface focus:ring-primary',
    outline: 'border border-border text-secondary bg-transparent hover:bg-surface focus:ring-primary',
    ghost: 'text-secondary hover:bg-surface focus:ring-primary',
    destructive: 'bg-error text-white hover:bg-red-600 focus:ring-error',
    link: 'text-primary underline hover:text-primary-dark p-0 focus:ring-0 focus:ring-offset-0',
    icon: 'p-2 text-secondary hover:bg-surface focus:ring-primary',
  };
  
  // Disabled classes
  const disabledClasses = 'opacity-50 cursor-not-allowed pointer-events-none';
  
  // Width classes
  const widthClasses = fullWidth ? 'w-full' : '';
  
  // Combine all classes
  const classes = [
    baseClasses,
    sizeClasses[size],
    variantClasses[variant],
    disabled || loading ? disabledClasses : '',
    widthClasses,
    className,
  ].join(' ');
  
  // If it's an icon-only button
  if (variant === 'icon' && icon) {
    return (
      <button
        type={type}
        className={classes}
        disabled={disabled || loading}
        onClick={onClick}
        {...props}
      >
        {loading ? (
          <Icon name="Loader" className="animate-spin" />
        ) : (
          <Icon name={icon} />
        )}
      </button>
    );
  }
  
  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <>
          <Icon name="Loader" className="mr-2 animate-spin" />
          <span>Loading...</span>
        </>
      ) : (
        <>
          {icon && iconPosition === 'left' && (
            <Icon name={icon} className="mr-2" />
          )}
          {children}
          {icon && iconPosition === 'right' && (
            <Icon name={icon} className="ml-2" />
          )}
        </>
      )}
    </button>
  );
};

export default Button;